export default function newTestPhoneNumber(): string {
  // This prefix is provided by ARCEP for testing purpose.
  const testPhoneNumberPrefix = "063998";
  return (
    testPhoneNumberPrefix +
    String(randomPhoneNumberDigit()) +
    String(randomPhoneNumberDigit()) +
    String(randomPhoneNumberDigit()) +
    String(randomPhoneNumberDigit())
  );
}

function randomPhoneNumberDigit(): number {
  return randomIntFromInterval(0, 9);
}

// min and max included
function randomIntFromInterval(min: number, max: number): number {
  return Math.floor(Math.random() * (max - min + 1) + min);
}
